import { render } from "./receive-detail.vue?vue&type=template&id=0c193ae6"
import script from "./receive-detail.vue?vue&type=script&lang=js"
export * from "./receive-detail.vue?vue&type=script&lang=js"

import "./receive-detail.vue?vue&type=style&index=0&id=0c193ae6&lang=less"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__